var map = {
	"./1.png": "fb27",
	"./2.png": "1e51",
	"./3.png": "6e82",
	"./4.png": "5ef0",
	"./5.png": "ac25",
	"./6.png": "aec9",
	"./7.png": "f37c",
	"./8.png": "0fde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f67";